import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#252525",
    "col1l": "#333333",
    "col1n": "#000000",
    "col2d": "#747474",
    "col2l": "#BFBFBF",
    "col2n": "#999999"
}
function LegSho018({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M147.3 12V8.4q-1.09-5.158-9.8-6.55Q124.15-.95 93.35.5q-9.7.5-19.45 1.75l-.15.05-.2-.05Q63.8 1 54.1.5 23.3-.95 9.95 1.85.564 3.35 0 9.25h.05q-.05.4-.05.85v.1l.05.1-.05.6v.35l.05.1-.05.3.05.1V12H147.3z"
                    id="LegSho018__Symbol_57_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M65.95 2.25L56.5.85Q46.7.15 39.35-.1q-13.5-.2-24.3 1.5l30-.15 20.9 1M91.4.85l-9.45 1.4 20.9-1 30 .15Q122.05-.3 108.6-.1q-7.4.25-17.2.95m55.9 9.35V8.1L82.45 8q-5.05-.2-7.65-.9h-.05q-.55-.2-.95-.35h-.05l-.05-.05q-.05.05-.1.05-.25.1-.55.2-.1 0-.2.05-2.6.8-7.9 1L0 8.1v2.1l64.95-.1q5.3-.2 7.9-1 .1-.05.2-.05.3-.1.55-.2.05 0 .1-.05l.05.05h.05q.4.15.95.35h.05q2.6.7 7.65.9l64.85.1z"
                    id="LegSho018__Symbol_55_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M1.9 0H0v8q.1-.05.2-.05.3-.1.55-.2.05 0 .1-.05l.05.05h.05q.4.15.95.35V0z"
                    id="LegSho018__Symbol_56_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M147.3 11.2V1.55l-64.85-.1q-5.05-.2-7.65-.9h-.05Q74.2.35 73.8.2h-.05L73.7.15q-.05.05-.1.05-.25.1-.55.2-.1 0-.2.05-2.6.8-7.9 1L0 1.55v9.65h64.25q5.95 0 8.6-1.3.4-.2.75-.45l.1-.1.1.1q.4.3.95.55 2.65 1.2 8.4 1.2h64.15z"
                    id="LegSho018__Symbol_53_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2l}
                    d="M147.3 3V1.4l-64.85-.1Q77.4 1.1 74.8.4h-.05Q74.2.2 73.8.05h-.05L73.7 0q-.05.05-.1.05-.25.1-.55.2-.1 0-.2.05-2.6.8-7.9 1L0 1.4V3l64.95-.1q5.3-.2 7.9-1 .1-.05.2-.05.3-.1.55-.2.05 0 .1-.05l.05.05h.05q.4.15.95.35h.05q2.6.7 7.65.9l64.85.1z"
                    id="LegSho018__Symbol_52_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M1.9.5Q1.35.3.95.15H.9L.85.1Q.8.15.75.15.5.25.2.35.1.35 0 .4v9.5q.1-.05.2-.05.3-.1.55-.2.05 0 .1-.05l.05.05h.05q.4.15.95.35V.5z"
                    id="LegSho018__Symbol_54_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#LegSho018__Symbol_57_0_Layer0_0_FILL"
                transform="translate(118.8 324.35)"
                id="LegSho018__col1n"
            />
            <use
                xlinkHref="#LegSho018__Symbol_55_0_Layer0_0_FILL"
                transform="translate(118.8 325.95)"
                id="LegSho018__col1l"
            />
            <use
                xlinkHref="#LegSho018__Symbol_56_0_Layer0_0_FILL"
                transform="translate(191.65 326.5)"
                id="LegSho018__col1d"
            />
            <use
                xlinkHref="#LegSho018__Symbol_53_0_Layer0_0_FILL"
                transform="translate(118.8 334.15)"
                id="LegSho018__col2n"
            />
            <use
                xlinkHref="#LegSho018__Symbol_52_0_Layer0_0_FILL"
                transform="translate(118.8 338.35)"
                id="LegSho018__col2l"
            />
            <use
                xlinkHref="#LegSho018__Symbol_54_0_Layer0_0_FILL"
                transform="translate(191.65 334.15)"
                id="LegSho018__col2d"
            />
        </g></g>
    )
}
export default LegSho018
